import Default from './AdditionalInfoColumn'
import {connect} from "react-redux"

export default connect()(Default)
